module.exports = __webpack_public_path__ + "static-v-shop/1782224859977/img/fotografos_01.fd31052e.jpg";